import VoyoButton from './VoyoButton';

export default VoyoButton;
